import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCartQuantity } from '@client/cart/hooks/cartQuantity/useCartQuantity';
import { useUserData } from '@client/context/hooks';
import { useProductBulkPrices } from '@client/product/hooks/useProductBulkPrices';
import { Icon, ICON_NAME, ICON_SIZE } from '@lib/components/Icon';
import { Price, PRICE_SIZE } from '@lib/components/Price';
import classNames from 'classnames';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import './BulkPricesV2.scss';

export const BulkPricesV2 = (): ReactElement | null => {
  const params = useParams<{ sku: string }>();
  const { setItemQuantity } = useCartQuantity();
  const { bulkPrices } = useProductBulkPrices(params.sku);
  const { isLoggedIn } = useUserData();
  const t = useTranslate();

  useEffect(() => () => {
    // Reset the quantity when the component unmounts
    setItemQuantity(params.sku, 1, 1);
  }, []);

  if (!bulkPrices.length || !isLoggedIn) {
    return null;
  }

  return (
    <div className='BulkPricesV2-Container'>
      <div className='BulkPricesV2-UpperIconWrapper'>
        <Icon name={ICON_NAME.bulk} size={ICON_SIZE.default} className='BulkPricesV2-Icon' />{t('Bulk pricing:')}
      </div>
      <div className='BulkPricesV2'>
        {bulkPrices?.map(({
          minQuantity,
          discountPercentage,
          priceWithoutVat,
        }, index) => index !== 0 && (
          <div
            className={
              classNames('BulkPricesV2-Item')
            }
            onClick={() => setItemQuantity(params.sku, minQuantity, minQuantity)}
            key={minQuantity}
          >
            <div className='BulkPricesV2-UpperWrapper'>
              <span className='BulkPricesV2-Title'>{t('Buy')}&nbsp;{minQuantity}</span>
              <div className='BulkPricesV2-PriceWrapper'>
                <Price
                  className='BulkPricesV2-Price'
                  price={priceWithoutVat}
                  currency='CHF'
                  size={PRICE_SIZE.small}
                />
                {' '}
                <span className='BulkPricesV2-PriceText'>
                  /&nbsp;{t('item')}
                </span>
              </div>
            </div>
            <div className='BulkPricesV2-DiscountWrapper'>
              <span className='BulkPricesV2-Discount'>{discountPercentage}%</span>
              <span className='BulkPricesV2-DiscountText-Short'>
                (CHF&nbsp;<strong>{(bulkPrices[0].priceWithoutVat - priceWithoutVat).toFixed(2)}</strong>)
              </span>
              <span className='BulkPricesV2-DiscountText-Full'>
                {t('SaveBulkPrices')} CHF&nbsp;
                <strong>{(bulkPrices[0].priceWithoutVat - priceWithoutVat).toFixed(2)}</strong> /&nbsp;item
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
